import createFetchDuck from '../../util/genericEntityDuck';

export const storeKey = 'alerts';
const duck = createFetchDuck('HEARTBEAT', storeKey, 'alertId', 'heartbeat');

export default duck;
export const { creators, reducer, types, selectors } = duck;
